import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { IYarnInput } from "../../modules/raw-material/models/yarn";
import { ILspInput } from "../../modules/orders/models/lsp";
import { IAccessoryInput } from "../../modules/orders/models/accessory";
interface ICreateYarnInput{
  input:IYarnInput,
  orderId:number,
}
interface ICreateLspInput{
  input:ILspInput,
  orderId:number,
}
interface ICreateAccessoryInput{
  input:IAccessoryInput,
  orderId:number,
}
export const initialYarnState: ICreateYarnInput = {
  orderId:0,
  input:{
      id: uuidv4(),
      yarn_compo: "",
      yarn_count: "",
      more_details: "",
      quality: null,
      name: null,
      micronage: null,
      yarn_details: [],
      isSelected: false,
      unit_id:0,
  }
};
const initialLspState:ICreateLspInput={
  orderId:0,
  input:{
    composition:"",
    count:"",
    name:"",
    reference:"",
    more_details:"",
    category_id:null,
    power_id:null,
    lsp_details:[],
    isSelected: false

  }
  
  
}
const initialeAccessoryState:ICreateAccessoryInput={
  orderId:0,
  input:{
    name:"",
    reference:"",
    more_details:"",
    acc_details:[],
    isSelected: false,
    size:'',
    category_id:0,
    unit_id:0,

  }
  
  
}

interface IPurchaserState {
    isAddingItem:boolean;
    currencyId:number;
    wUnitId:number;
    currentYarnEdit:ICreateYarnInput;
    currentLspEdit:ICreateLspInput;
    currentAccessoryEdit:ICreateAccessoryInput
}

const initialState: IPurchaserState = {
    isAddingItem:false,
    currencyId:0,
    wUnitId:0, 
    currentYarnEdit:initialYarnState,
    currentAccessoryEdit:initialeAccessoryState,
    currentLspEdit:initialLspState,
};

const itemManagementSlice = createSlice({
  name: "item_management",
  initialState,
  reducers: {
    setIsAddingItem(state, action){
       state.isAddingItem=action.payload
    },
    setCurrency(state,action){
      state.currencyId=action.payload;
    },
    setWUnit(state, action){
      state.wUnitId=action.payload;
    },
    setCurrentYarnState(state, action){
       state.currentYarnEdit=action.payload
    },
    setCurrentAccessoryState(state, action){
       state.currentAccessoryEdit=action.payload
    },
    setCurrentLspState(state, action){
       state.currentLspEdit=action.payload
    },
    resetItemManagementEditState(state) {
      state.isAddingItem = false;
      state.currencyId = 0;
      state.wUnitId = 0;
      state.currentYarnEdit = initialYarnState;
      state.currentAccessoryEdit = initialeAccessoryState;
      state.currentLspEdit = initialLspState;
    },
 
  }
});

export const {setIsAddingItem,setCurrency,setWUnit,setCurrentYarnState,setCurrentLspState,setCurrentAccessoryState,resetItemManagementEditState} =
  itemManagementSlice.actions;
export default itemManagementSlice.reducer;
